export default {
    onsiteStatus: 'Check in Onsite Status',
    noDataMessage: 'There is no check in onsite\'s employee today',
    employeeId: 'Employee ID',
    name: 'Employee Name',
    bureauShort: 'Bureau Acronym',
    positionShort: 'Position Acronym',
    date: 'Date',
    checkInTime: 'Check in Time',
    status: 'Status'
}
